import { Container } from "react-bootstrap";
import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const ContainerStyled = styled(Container)`
  height: 100vh;
  display: flex;
  max-width: 100vw;
  overflow: hidden;
  padding: 0 !important;
  background-color: ${theme.colors.blue900};
  flex-direction: row;
`;

export const ContentStyled = styled(Container)`
  height: 100vh;
  display: flex;
  max-width: 100%;
  overflow: hidden;
  padding: 0 !important;
  flex-direction: column;
`;

export const RightIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 0;
  bottom: 13%;
  margin-right: 16px;
  margin-bottom: 0px;
`;

export const CenterContent = styled.div`
  padding: 0 30px;
  height: calc(100% - 100px);
  display: block;

  .home-wrapper {
    &::-webkit-scrollbar {
      width: 3px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: ${theme.colors.lightGray5};
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: ${theme.colors.lightGray};
      border-radius: 3px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: ${theme.colors.lightGray6};
    }
  }

  @media screen and (max-width: 768px) {
    padding: 0 15px;
  }
`;

export const ButtonsContainer = styled.div`
  position: absolute;
  right: 15px;
  bottom: 90px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;
